module.exports = __webpack_public_path__ + "static/media/christmas.a260f3e0.jpg";